import {
  ApolloProvider,
  ApolloClient,
  HttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { useAuth0 } from "@auth0/auth0-react";

import { ENV } from "../../utils/getEnv";

const API_URL = ENV.API_URL;

const Provider = ({ children }) => {
  const { getAccessTokenSilently } = useAuth0();

  const authLink = setContext(async (_, { headers }) => {
    const token = await getAccessTokenSilently();

    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const link = new HttpLink({
    uri: `${API_URL}/graphql`,
    fetch: (uri, options) => {
      const { body } = options;
      try {
        const { operationName } = JSON.parse(body);
        if (operationName) {
          uri = `${uri}?${operationName}`;
        }
      } catch (error) {
        // can't find operationName, ignore
      }
      return fetch(uri, options);
    },
  });

  const client = new ApolloClient({
    link: authLink.concat(link),
    cache: new InMemoryCache(),
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default Provider;
